import { render } from "./DialogVoltura.vue?vue&type=template&id=f9ca4fea&scoped=true"
import script from "./DialogVoltura.vue?vue&type=script&lang=js"
export * from "./DialogVoltura.vue?vue&type=script&lang=js"

import "./DialogVoltura.vue?vue&type=style&index=0&id=f9ca4fea&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9ca4fea"]])

export default __exports__